import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { UIChart } from 'primeng/chart';
import { ProspectsService } from '../shared/services/prospects.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { saveAs } from 'file-saver';

interface SummaryAppProspect {
  year: number;
  month: number;
  countOfProspects: number;
  countOfActivities: number;
}
@Component({
  selector: 'app-app-prospect-summary',
  templateUrl: './app-prospect-summary.component.html',
  styleUrl: './app-prospect-summary.component.scss'
})
export class AppProspectSummaryComponent implements OnInit {
@ViewChild('dtMonthlyProspectSummary') monthlyTable: Table;
  @ViewChild('monthlyProspectChart') monthlyProspectChart: UIChart;

  monthlyProspectSummary: SummaryAppProspect[] = [];
  filteredMonthlyProspectSummary: SummaryAppProspect[] = [];
  monthlyProspectChartData: any;
  monthlyProspectChartOptions: any;
  selectedYear: number | null = null;
  selectedCountType: string = 'countOfActivities'; // Default to Activity Count as per image
  yearOptions: any[] = [];
  countTypeOptions: any[] = [
    { label: 'Prospect Count', value: 'countOfProspects' },
    { label: 'Activity Count', value: 'countOfActivities' }
  ];

  private monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  private colors = [
    '#42A5F5', // Blue
    '#FF4081', // Pink
    '#66BB6A', // Green
    '#FFA726', // Orange
    '#AB47BC', // Purple
    '#26C6DA', // Cyan
    '#EC407A', // Magenta
    '#5C6BC0', // Indigo
    '#29B6F6', // Light Blue
    '#26A69A', // Teal
  ];
private prospectColors = [
  '#42A5F5', // Blue
  '#66BB6A', // Green
  '#AB47BC', // Purple
  '#FFA726', // Orange
  '#26C6DA', // Cyan
];

private activityColors = [
  '#FF4081', // Pink
  '#f5c710', // Magenta
  '#0baa1e', // Indigo
  '#2b00ff', // Light Blue
  '#036d72', // Teal
];


  private fakeData = 
  [
  { "year": 2024, "month": 1, "countOfProspects": 65, "countOfActivities": 30 },
  { "year": 2024, "month": 2, "countOfProspects": 60, "countOfActivities": 45 },
  { "year": 2024, "month": 3, "countOfProspects": 80, "countOfActivities": 40 },
  { "year": 2024, "month": 4, "countOfProspects": 75, "countOfActivities": 20 },
  { "year": 2024, "month": 5, "countOfProspects": 60, "countOfActivities": 85 },
  { "year": 2024, "month": 6, "countOfProspects": 55, "countOfActivities": 30 },
  { "year": 2024, "month": 7, "countOfProspects": 40, "countOfActivities": 90 },
  { "year": 2025, "month": 1, "countOfProspects": 30, "countOfActivities": 50 },
  { "year": 2025, "month": 2, "countOfProspects": 50, "countOfActivities": 40 },
  { "year": 2025, "month": 3, "countOfProspects": 70, "countOfActivities": 60 },
  { "year": 2025, "month": 4, "countOfProspects": 60, "countOfActivities": 20 },
  { "year": 2025, "month": 5, "countOfProspects": 50, "countOfActivities": 80 },
  { "year": 2025, "month": 6, "countOfProspects": 45, "countOfActivities": 30 },
  { "year": 2025, "month": 7, "countOfProspects": 40, "countOfActivities": 70 },
  { "year": 2025, "month": 12, "countOfProspects": 140, "countOfActivities": 170 },
  { "year": 2025, "month": 10, "countOfProspects": 100, "countOfActivities": 150 },
  { "year": 2023, "month": 7, "countOfProspects": 50, "countOfActivities": 90 },
  { "year": 2023, "month": 7, "countOfProspects": 50, "countOfActivities": 90 },
  { "year": 2023, "month": 8, "countOfProspects": 60, "countOfActivities": 80 },  
  { "year": 2023, "month": 9, "countOfProspects": 70, "countOfActivities": 70 },
  { "year": 2023, "month": 10, "countOfProspects": 80, "countOfActivities": 60 },
  { "year": 2023, "month": 11, "countOfProspects": 90, "countOfActivities": 50 },
  { "year": 2023, "month": 12, "countOfProspects": 100, "countOfActivities": 40 },
  { "year": 2022, "month": 5, "countOfProspects": 50, "countOfActivities": 30 },
  { "year": 2022, "month": 25, "countOfProspects": 15, "countOfActivities": 202 },
  { "year": 2022, "month": 8, "countOfProspects": 95, "countOfActivities": 105 },
  { "year": 2022, "month": 7, "countOfProspects": 100, "countOfActivities": 55 },
  { "year": 2022, "month": 2, "countOfProspects": 150, "countOfActivities": 10 }
]

  constructor(private prospectsService: ProspectsService) {}

  ngOnInit(): void {
    this.initializeMonthlyProspectChart();

    this.loadMonthlyProspectSummary();

  }

  loadMonthlyProspectSummary() {
    this.prospectsService.getAllProspectSummaryByYearAndMonth()
      .toPromise()
      .then(response => {
        this.monthlyProspectSummary = response;
        this.filteredMonthlyProspectSummary = response;
        this.updateYearOptions();
        this.updateMonthlyProspectChartData();
      })
      .catch(error => {
        console.error('Error loading monthly prospect summary:', error);
      });

    // Mock data for development
    // this.monthlyProspectSummary = this.fakeData;
    // this.filteredMonthlyProspectSummary = this.fakeData;
    // this.updateYearOptions();
    // this.updateMonthlyProspectChartData();
  }

  updateYearOptions() {
    const years = [...new Set(this.monthlyProspectSummary.map(item => item.year))].sort();
    this.yearOptions = [{ label: 'All Years', value: null }, ...years.map(year => ({ label: year.toString(), value: year }))];
    this.selectedYear = null; // Default to all years
  }

  initializeMonthlyProspectChart() {
    this.monthlyProspectChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      aspectRatio: 2, // Fixed aspect ratio to control size
      scales: {
        x: {
          title: {
            display: true,
            text: 'Month'
          }
        },
        y: {
          beginAtZero: true,
    
          title: {
            display: true,
            text: this.selectedCountType === 'countOfProspects' ? 'Prospect Count' : 'Activity Count'
          }
        }
      },
      plugins: {
        tooltip: {
          callbacks: {
            title: (tooltipItems) => {
              const month = tooltipItems[0].label;
              return month;
            },
            label: (tooltipItem) => {
              const value = tooltipItem.raw;
              const datasetLabel = tooltipItem.dataset.label;
              const yearTotal = this.getYearTotal(datasetLabel, this.selectedCountType);
            return [
                `Count: ${value}`,
                `${datasetLabel} (total): ${yearTotal}`
              ];
            }
          }
        },
        legend: {
          position: 'top',
          labels: {
            boxWidth: 10
          }
        }
      },
      layout: {
        padding: {
          left: 10,
          right: 10,
          top: 20,
          bottom: 20
        }
      },
      elements: {
        point: {
          radius: 3
        },
        line: {
          tension: 0.4,
          borderWidth: 2
        }
      },
      resizeDelay: 200
    };
  }

  getYearTotal(year: string, countType: string): number {
    const yearNum = parseInt(year, 10);
    const yearData = this.filteredMonthlyProspectSummary.filter(item => item.year === yearNum);
    if (countType === 'countOfProspects') {
      return yearData.reduce((sum, item) => sum + item.countOfProspects, 0);
    } else {
      return yearData.reduce((sum, item) => sum + item.countOfActivities, 0);
    }
  }



updateMonthlyProspectChartData() {
  const filteredData = this.selectedYear !== null
    ? this.filteredMonthlyProspectSummary.filter(item => item.year === this.selectedYear)
    : this.filteredMonthlyProspectSummary;

  // Group data by year
  const dataByYear: { [year: number]: { [month: number]: { prospects: number; activities: number } } } = {};
  filteredData.forEach(item => {
    if (!dataByYear[item.year]) {
      dataByYear[item.year] = {};
    }
    dataByYear[item.year][item.month] = {
      prospects: item.countOfProspects,
      activities: item.countOfActivities
    };
  });

  // Sort years to assign colors dynamically
  const years = Object.keys(dataByYear).map(Number).sort();
  const labels = this.monthNames; // All 12 months
  const datasets = [];

  years.forEach((year, index) => {
    const dataByMonth: number[] = [];
    for (let month = 1; month <= 12; month++) {
      dataByMonth.push(
        dataByYear[year][month]?.[
          this.selectedCountType === 'countOfProspects' ? 'prospects' : 'activities'
        ] || 0
      );
    }

    // Use different color palettes for prospects vs activities
    const colorPalette = this.selectedCountType === 'countOfProspects'
      ? this.prospectColors
      : this.activityColors;

    const color = colorPalette[index % colorPalette.length];

    datasets.push({
      label: `${year}`,
      data: dataByMonth,
      borderColor: color,
      backgroundColor: color + '90', // Add alpha for background (20%)
      fill: false,
      tension: 0.4
    });
  });

  this.monthlyProspectChartData = {
    labels: labels,
    datasets: datasets
  };

  // Update y-axis title dynamically
  this.monthlyProspectChartOptions.scales.y.title.text =
    this.selectedCountType === 'countOfProspects' ? 'Prospect Count' : 'Activity Count';

  if (this.monthlyProspectChart) {
    this.monthlyProspectChart.reinit();
  }
}

  getMonthName(month: number): string {
    return this.monthNames[month - 1] || 'Unknown';
  }

  onYearChange() {
    this.updateMonthlyProspectChartData();
  }

  onCountTypeChange() {
    this.updateMonthlyProspectChartData();
  }

  onMonthlyTableFilter(event: any) {
    this.filteredMonthlyProspectSummary = event.filteredValue || [];
    this.updateYearOptions();
    this.updateMonthlyProspectChartData();
  }

  exportMonthlyProspectPdf() {
    const doc = new jsPDF('landscape', 'pt', 'a4');

    const columns = [
      { header: '#', dataKey: 'index' },
      { header: 'Year', dataKey: 'year' },
      { header: 'Month', dataKey: 'month' },
      { header: 'Prospect Count', dataKey: 'countOfProspects' },
      { header: 'Activity Count', dataKey: 'countOfActivities' }
    ];

    const data = this.filteredMonthlyProspectSummary;

    const rows = data.map((row: any, index: number) => ({
      index: index + 1,
      year: row.year,
      month: this.getMonthName(row.month),
      countOfProspects: row.countOfProspects,
      countOfActivities: row.countOfActivities
    }));

    autoTable(doc, {
      columns: columns,
      body: rows,
      theme: 'grid',
      styles: {
        font: 'helvetica',
        fontSize: 10,
        cellPadding: 2,
        overflow: 'linebreak',
        cellWidth: 'wrap'
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontSize: 10,
        fontStyle: 'bold',
        halign: 'center'
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240]
      },
      columnStyles: {
        index: { cellWidth: 26, halign: 'center' },
        year: { cellWidth: 50, halign: 'center' },
        month: { cellWidth: 70, halign: 'center' },
        countOfProspects: { cellWidth: 70, halign: 'center' },
        countOfActivities: { cellWidth: 70, halign: 'center' }
      },
      margin: { top: 20 }
    });

    doc.save('MonthlyProspectSummary.pdf');
  }

  exportMonthlyProspectExcel() {
    import('xlsx').then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.filteredMonthlyProspectSummary.map(summary => ({
        'Year': summary.year,
        'Month': this.getMonthName(summary.month),
        'Prospect Count': summary.countOfProspects,
        'Activity Count': summary.countOfActivities
      })));

      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, 'MonthlyProspectSummary');
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  exportMonthlyProspectChartAsImage() {
    if (this.monthlyProspectChart && this.monthlyProspectChart.chart) {
      const chart = this.monthlyProspectChart.chart;
      const canvas = chart.canvas;
      const ctx = canvas.getContext('2d');

      ctx.save();
      ctx.globalCompositeOperation = 'destination-over';
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      const base64Image = canvas.toDataURL('image/png');
      ctx.restore();

      const link = document.createElement('a');
      link.href = base64Image;
      link.download = 'monthly-prospect-summary-chart.png';
      link.click();
    }
  }

  exportMonthlyProspectChartAsPDF() {
    if (this.monthlyProspectChart && this.monthlyProspectChart.chart) {
      const chart = this.monthlyProspectChart.chart;
      const canvas = chart.canvas;
      const ctx = canvas.getContext('2d');

      ctx.save();
      ctx.globalCompositeOperation = 'destination-over';
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      const base64Image = canvas.toDataURL('image/png');
      ctx.restore();

      const imgWidth = 280;
      const imgHeight = (canvas.height / canvas.width) * imgWidth;

      const pdf = new jsPDF('landscape');
      pdf.addImage(base64Image, 'PNG', 10, 10, imgWidth, imgHeight);
      pdf.save('monthly-prospect-summary-chart.pdf');
    }
  }
}
